/**
 * @generated SignedSource<<345cdcc4a5f30bb844cb8f9e476b52b7>>
 * @relayHash 296f5d76497003b9efc4db58170d3c04
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 310bfbced7ee7a0f7321719746db0b9812584400fb073bf58476709972041428

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiServiceHubDetailsPageQuery } from './uiServiceHubDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<uiServiceHubDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "310bfbced7ee7a0f7321719746db0b9812584400fb073bf58476709972041428",
    "metadata": {},
    "name": "uiServiceHubDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
